import $ from "jquery";
import TabManager from "../customTabComponent/customTabComponent";

// The filters are rendered more than once (desktop accordion and mobile
// modal, and once per job listing on the page), so each checkbox gets an id
// that is unique on the page; a repeated id paired the labels with the wrong
// checkboxes (WCAG 1.3.1, 4.1.2). Counted per page, not per listing.
let checkboxCount = 0;

const createJobListing = (container) => {
  const variables = {
    jobListingContainerElement: container,
    jobFilterTab: "job-filter-tab",
    filterCityContainer: ".filter__city__container",
    filterExpertiesContainer: ".filter__experties__container",
    applyFilterBtn: ".apply-filter",
    searchInput: ".search-input",
    filteredTagCity: ".filtered__tag__city",
    filteredTagExperties: ".filtered__tag__experties",
    allFilterTags: ".all__filter__tags",
    clearFilterBtn: ".clear__filter",
    closeTag: ".close__tag",
    noDataFoundMessage: ".no-data-found",
    url: window.location.href,
  };

  const elements = {
    loadMoreClick: $(".job_loadmore"),
  };

  const loadMoreJobs = () => {
    elements.loadMoreClick.each(function () {
      let jobComp = $(this).parents(".job-listing");
      let count = jobComp.find(`.job-item`).length;
      let limit = parseInt($(this).attr("data-limit"));
      let counter = parseInt($(this).attr("data-counter"));

      if (count > limit) {
        $(this).on("click", function () {
          for (let i = counter + 1; i <= counter + limit; i++) {
            jobComp
              .find(`.job-item:eq(${i - 1})`)
              .toggleClass("d-none d-block");
          }
          counter += limit;
          $(this).attr("data-counter", counter);
          if (counter >= count) {
            $(this).hide();
          }
        });
      } else {
        $(this).hide();
      }
    });
  };

  const cacheSelectors = () => {
    elements.$jobListingContainer = $(variables.jobListingContainerElement);
    elements.$filterCityContainer = elements.$jobListingContainer.find(
      variables.filterCityContainer
    );
    elements.$filterExpertiesContainer = elements.$jobListingContainer.find(
      variables.filterExpertiesContainer
    );
    elements.$applyFilterBtn = elements.$jobListingContainer.find(
      variables.applyFilterBtn
    );
    elements.$searchInput = elements.$jobListingContainer.find(
      variables.searchInput
    );
    elements.$filteredTagCity = elements.$jobListingContainer.find(
      variables.filteredTagCity
    );
    elements.$filteredTagExperties = elements.$jobListingContainer.find(
      variables.filteredTagExperties
    );
    elements.$allFilterTags = elements.$jobListingContainer.find(
      variables.allFilterTags
    );
    elements.$clearFilterBtn = elements.$jobListingContainer.find(
      variables.clearFilterBtn
    );
    elements.$closeTag = elements.$jobListingContainer.find(variables.closeTag);
    elements.$noDataFoundMessage = elements.$jobListingContainer.find(
      variables.noDataFoundMessage
    );
  };

  const createDataForFilter = () => {
    const { $jobListingContainer } = elements;
    const $elements = $jobListingContainer.find("[data-filter-item]");
    const cityData = new Set();
    const expertiseData = new Set();

    $elements.each((_, element) => {
      const $element = $(element);
      const city = $element.data("joblocation");
      const expertise = $element.data("experties");

      if (city) {
        cityData.add(city);
      }
      if (expertise) {
        try {
          const formattedExpertise = expertise
            .replace(/[{}]/g, "")
            .split(",")
            .map((item) => item.replace("=true", "").trim());

          formattedExpertise.forEach((exp) => expertiseData.add(exp));
          $element.attr(
            "data-new-experties",
            JSON.stringify(formattedExpertise)
          );
        } catch (e) {
          console.error("Failed to parse expertise JSON", e);
        }
      }
    });

    createCheckboxUI([...cityData], elements.$filterCityContainer);
    createCheckboxUI([...expertiseData], elements.$filterExpertiesContainer);
  };

  const createCheckboxUI = (data, $wrapperElement) => {
    $wrapperElement.empty();
    // The selector can match more than one container (accordion and tab view),
    // so the markup is built separately for each one: appending one string to
    // all of them copied the same ids into every container.
    $wrapperElement.each((_, wrapper) => {
      const checkboxHtml = data
        .map((item) => {
          const lowercaseItem = item.charAt(0) + item.slice(1).toLowerCase();
          checkboxCount += 1;
          const checkboxId = `job-filter-checkbox-${checkboxCount}`;

          return `
                        <div class="chli__checkbox">
                            <input type="checkbox" id="${checkboxId}" value="${lowercaseItem}">
                            <label for="${checkboxId}">${lowercaseItem}</label>
                        </div>
                    `;
        })
        .join("");
      $(wrapper).append(checkboxHtml);
    });
  };

  const applyFilters = () => {
    const selectedCities = elements.$filterCityContainer
      .find("input:checked")
      .map((_, el) => $(el).val())
      .get();
    const selectedExpertise = elements.$filterExpertiesContainer
      .find("input:checked")
      .map((_, el) => $(el).val())
      .get();
    const searchQuery = elements.$searchInput.val().toLowerCase();

    filterJobListings(selectedCities, selectedExpertise, searchQuery);

    const allTag = [...selectedCities, ...selectedExpertise];
    allTag.forEach((tag) => {
      createTag(tag, elements.$allFilterTags);
    });
  };

  const matchesQuery = ($element, query) => {
    const searchAttributes = elements.$searchInput
      .data("search-attributes")
      .split(",");
    return searchAttributes.some((attr) =>
      ($element.data(attr) || "").toLowerCase().includes(query)
    );
  };

  const filterJobListings = (cities, expertise, query) => {
    const { $jobListingContainer, $noDataFoundMessage } = elements;
    const $elements = $jobListingContainer.find("[data-filter-item]");
    let anyVisible = false;

    $elements.each((_, element) => {
      const $element = $(element);
      const city = $element.data("joblocation");
      let elementExpertise = $element.data("new-experties");

      try {
        if (typeof elementExpertise === "string") {
          elementExpertise = JSON.parse(elementExpertise);
        }
      } catch (e) {
        console.error("Failed to parse expertise JSON", e);
      }

      const matches = matchesQuery($element, query);
      const cityMatch = cities.length === 0 || cities.includes(city);
      const expertiseMatch =
        expertise.length === 0 ||
        expertise.some((exp) => elementExpertise.includes(exp.toUpperCase()));

      const isVisible = cityMatch && expertiseMatch && matches;
      $element.toggle(isVisible);
      if (isVisible) {
        anyVisible = true;
      }
    });

    if (anyVisible) {
      $noDataFoundMessage.hide();
    } else {
      $noDataFoundMessage.show();
    }
  };

  const debounceSearch = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func.apply(this, args), delay);
    };
  };

  const handleSearch = () => {
    applyFilters();
  };

  const handleCheckboxClick = (event, tagContainer) => {
    const $checkbox = $(event.target);
    const isChecked = $checkbox.prop("checked");
    const value = $checkbox.val();

    if (isChecked) {
      createTag(value, tagContainer);
    } else {
      tagContainer.find(`.filter__tag:contains("${value}")`).remove();
    }
  };

  const createTag = (value, container) => {
    if (container.find(`.filter__tag:contains("${value}")`).length > 0) {
      return; // Exit if tag already exists
    }

    const tag = $(`
            <div class="filter__tag">
                ${value}
               <svg data-tag="${value}" width="16" height="16" class="close__tag cursor-pointer">
                    <use
                    href="/etc.clientlibs/chli/clientlibs/clientlib-site/resources/images/sprite/sprite.svg#close"
                ></use>
                    </svg>
            </div>
        `);
    container.append(tag);
    tag.find(".close__tag").on("click", function () {
      const tagToRemove = $(this).data("tag");
      $(this).closest(".filter__tag").remove();
      elements.$jobListingContainer
        .find(`input[value="${tagToRemove}"]`)
        .prop("checked", false);

      const matchesMediaQuery = window.matchMedia("(max-width: 767px)").matches;
      if (matchesMediaQuery) {
        applyFilters();
      }
    });
  };

  const dataLayerObj = (e) => {
    var obj = {
      articleName: "",
      blogCategory: "",
      blogPageCategory: "",
      buttonText: "",
      pageSection: "Job Listing",
      pageType:
        document.querySelector("meta[name='template']").content ==
        "chli-base-page-template"
          ? variables.url.includes("blog")
            ? "Blogs"
            : variables.url.substring(
                variables.url.indexOf(".com/"),
                variables.url.lastIndexOf("/") === ".com"
              ) &&
              !variables.url
                .substring(
                  variables.url.indexOf(".com/"),
                  variables.url.length - 1
                )
                .includes("/")
            ? "Home"
            : "Other Pages"
          : "Blog Details Page",
      planOption: "",
      productCategory: "",
      productName: "",
      question: "",
      source: "",
      searchTerm: "",
      videoTitle: "",
      bannerName: "",
      searchTerm: e ? e.replace(/\n/g, "").trim() : "",
    };
    return obj;
  };

  const clearFilters = () => {
    elements.$filterCityContainer.find("input:checked").prop("checked", false);
    elements.$filterExpertiesContainer
      .find("input:checked")
      .prop("checked", false);
    elements.$searchInput.val("");
    elements.$allFilterTags.empty();
    elements.$filteredTagCity.empty();
    elements.$filteredTagExperties.empty();
    applyFilters();
  };

  const init = () => {
    cacheSelectors();
    const filterTab = new TabManager(variables.jobFilterTab);
    filterTab.init(elements.$jobListingContainer);
    createDataForFilter();
    elements.$applyFilterBtn.on("click", applyFilters);
    elements.$clearFilterBtn.on("click", clearFilters);
    elements.$searchInput.on("input", debounceSearch(handleSearch, 300));

    elements.$filterCityContainer.on(
      "change",
      'input[type="checkbox"]',
      (event) => {
        handleCheckboxClick(event, elements.$filteredTagCity);
      }
    );

    elements.$filterExpertiesContainer.on(
      "change",
      'input[type="checkbox"]',
      (event) => {
        handleCheckboxClick(event, elements.$filteredTagExperties);
      }
    );
    $(".job-listing .search-input").on("keyup", function () {
      let buttonText = document.querySelector(
        ".job-listing .search-input"
      ).value;
      let obj = dataLayerObj(buttonText);
      createDataLayer("enter_search_keyword", obj);
    });
    $(".job-listing .search-input").on("focus", function () {
      let buttonText = document.querySelector(
        ".job-listing .search-input"
      ).value;
      let obj = dataLayerObj(buttonText);
      createDataLayer("searchClicked", obj);
    });
    $(".job-card .chli_btn--primary").on("click", function (e) {
      let obj = dataLayerObj(e.currentTarget.innerText);
      createDataLayer("buttonClick", obj);
    });
    if ($(".job-listing__cards").length > 0) {
      loadMoreJobs();
    }
  };

  init();
};

$(() => {
  $(".job-listing").each((_, container) => {
    createJobListing(container);
  });
});
